// extracted by mini-css-extract-plugin
export default {"item-tag-container":"ItemTags_item-tag-container__hT3ES","item-tags-item":"ItemTags_item-tags-item__wV-yt"};